module.exports = __webpack_public_path__ + "img/cutting.b697d71d.svg";